import {useCurrentPageType} from '@aboutyou/router';
import {useTrackOriginClick} from '@aboutyou/tracking';
import {mediaDesktopAndUp, mediaLargeScreens} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {PropsWithChildren, Suspense} from 'react';

export const FooterLayout: React.FC<
  PropsWithChildren<{noMargin?: boolean}>
> = ({children, noMargin: noMarginProp}) => {
  const trackOriginClick = useTrackOriginClick();
  const noMargin = useCurrentPageType() === 'checkout' || noMarginProp;

  return (
    <Suspense>
      <FooterLayoutGrid
        $noMargin={noMargin}
        data-testid="footer"
        onClick={trackOriginClick('footer')}
      >
        {children}
      </FooterLayoutGrid>
    </Suspense>
  );
};

export const FooterLayoutAreas = {
  STATIC: {
    PAYMENT_SECTION: 'payment-section',
    NEWS_LETTER: 'newsletter',
    SECTION_LINKS: 'static-section-links',
    GROUPED_SECTIONS: 'grouped-sections',
    FLEXIBLE_SECTIONS: 'flexible-sections',
    LEGAL_LINKS: 'legal-links',
  },
  DYNAMIC: {
    SEO_TEXT: 'seo-text',
    SECTION_LINKS: 'dynamic-section-links',
  },
} as const;

const FooterLayoutGrid = styled.footer<{$noMargin?: boolean}>`
  display: grid;
  margin-top: ${props => (props.$noMargin ? '0' : '3rem')};
  content-visibility: auto;
  contain-intrinsic-size: 2500px;

  @media ${mediaDesktopAndUp} {
    contain-intrinsic-size: 2000px;
  }
  @media ${mediaLargeScreens} {
    contain-intrinsic-size: 1500px;
  }

  grid-template-areas:
    '${FooterLayoutAreas.STATIC.PAYMENT_SECTION}'
    '${FooterLayoutAreas.STATIC.NEWS_LETTER}'
    '${FooterLayoutAreas.DYNAMIC.SEO_TEXT}'
    '${FooterLayoutAreas.STATIC.SECTION_LINKS}'
    '${FooterLayoutAreas.DYNAMIC.SECTION_LINKS}'
    '${FooterLayoutAreas.STATIC.GROUPED_SECTIONS}'
    '${FooterLayoutAreas.STATIC.FLEXIBLE_SECTIONS}'
    '${FooterLayoutAreas.STATIC.LEGAL_LINKS}';
`;

export const FooterLayoutSlot = styled.div<{
  area:
    | (typeof FooterLayoutAreas.DYNAMIC)[keyof typeof FooterLayoutAreas.DYNAMIC]
    | (typeof FooterLayoutAreas.STATIC)[keyof typeof FooterLayoutAreas.STATIC];
}>`
  grid-area: ${props => props.area};
  max-width: 100vw;
  overflow-x: hidden;

  display: flex;
  flex-direction: column;
`;
